import { AfterContentInit } from '@angular/core';
import { UIInputDirective } from './input.directive';
var UIInputComponent = /** @class */ (function () {
    function UIInputComponent() {
    }
    Object.defineProperty(UIInputComponent.prototype, "value", {
        get: function () {
            return this.input.value;
        },
        enumerable: true,
        configurable: true
    });
    UIInputComponent.prototype.ngAfterContentInit = function () {
        var _this = this;
        if (this.input) {
            this.input.onBlur.subscribe(function () {
                _this.focused = false;
            });
            this.input.onFocus.subscribe(function () {
                _this.focused = true;
            });
        }
    };
    UIInputComponent.prototype.ngOnDestroy = function () {
        this._destroyInput();
    };
    UIInputComponent.prototype._destroyInput = function () {
        if (this._onBlurSubscription) {
            this._onBlurSubscription.unsubscribe();
            this._onBlurSubscription = null;
        }
        if (this._onFocusSubscription) {
            this._onFocusSubscription.unsubscribe();
            this._onFocusSubscription = null;
        }
    };
    return UIInputComponent;
}());
export { UIInputComponent };
